module.exports = "<p>\r\n  salir works!\r\n</p>\r\n"


//////////////////
// WEBPACK FOOTER
// C:/Apache24/htdocs/ostimar/frontend/src/app/components/salir/salir.component.html
// module id = ../../../../../src/app/components/salir/salir.component.html
// module chunks = main